import { Pipe, PipeTransform } from '@angular/core';
import { Tournament } from './../../models/tournament';
@Pipe({
    name: 'userFilter',
    pure: false
})
export class UserPipe implements PipeTransform {
    transform(items: any[], filter: any): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter((item: any) => this.applyFilter(item, filter));
    }
    applyFilter(book: any, filter: any): boolean {
        for (const field in filter) {
            if (book[field]) {
                if (filter[field]) {
                    if (typeof filter[field] === 'string') {

                        if (book[field].toLowerCase().indexOf(filter[field].toLowerCase()) === -1) {
                            return false;
                        }
                    } else if (typeof filter[field] === 'number') {
                        if (book[field] !== filter[field]) {
                            return false;
                        }
                    } else if (filter[field] === 'date') {
                        if (book[field] !== filter[field]) {
                            return false;
                        }
                    }
                }
            }

        }
        return true;
    }
}